var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard24X16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83693 4.06947H14.1631V11.9306H9.83693V4.06947Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1116 8C10.1116 6.40278 10.8532 4.98611 11.9931 4.06945C11.1554 3.40278 10.0979 3 8.94421 3C6.21116 3 4 5.23611 4 8C4 10.7639 6.21116 13 8.94421 13C10.0979 13 11.1554 12.5972 11.9931 11.9306C10.8532 11.0278 10.1116 9.59722 10.1116 8Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8C20 10.7639 17.7888 13 15.0558 13C13.9021 13 12.8446 12.5972 12.0069 11.9306C13.1605 11.0139 13.8884 9.59722 13.8884 8C13.8884 6.40278 13.1468 4.98611 12.0069 4.06945C12.8446 3.40278 13.9021 3 15.0558 3C17.7888 3 20 5.25 20 8Z",
    fill: "#F79E1B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 15,
    rx: 1.5,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard24X16);
export default __webpack_public_path__ + "static/media/mastercard24x16.1d090e467b5571c42435b3cae7d1532f.svg";
export { ForwardRef as ReactComponent };